<template>
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 mx-auto mt-4">
        <table class="w-full leading-normal text-gray"
               style="border: solid 1px #dedede;">
          <thead class="bg-gray-pale" >
          <tr>
            <th colspan="12" class="py-2">
              <span class="px-2">Secretary</span>
            </th>
          </tr>
          </thead>
          <tbody>
             <LegalPersonsDetails v-if="getCompanySecretary != null" class="p-1" :persons="[getCompanySecretary.data]"/>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useBusinessFileStore } from "@/stores/business-file";
import LegalPersonsDetails
  from "@/domains/home/services/registry/business/files/tabs/company_data/LegalPersonsDetails.vue";

const fileStore = useBusinessFileStore();

const getCompanySecretary = computed(() => fileStore.secretary);
</script>

